import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState, IDonorConversionPostResponse } from "../";
import { IBaseResponse, IListItem, IMicrositeRecipient, IMicrositeRecipientBulkDeactivationRequest, ICenterBase, IExistingRegistration, IRemoteDonorRegistration, IConvertDonationType, IMicrositeConvertDonationType } from '@nkr/models/index';
import { IContact, IMicrositeCounts, IMicrositeRecipientForList, IMicrositeRecipientRequest } from '@nkr/models/index';
import { IPost } from '../authorization';
import { IGet, IPut } from '../authorization/actions';
import { MicrositeEmailType, MicrositeListType, MicrositeRecipientStatus, ShortCodeType } from '@nkr/enums/index';
import { ActionCreators as ActionCreatorsCampaign, IMicrositeCampaignListResponse, IMicrositeCampaignResponse, IMicrositeCampaignValidatedMailingListResponse, IMicrositeCampaignLookupDataResponse } from './actions-campaign';
import { ActionCreators as ActionCreatorsCoach, ICoachLogEntryResponse, ICommunicationResponse, IChangeCoachStatusRequest } from './actions-coach';
import { ActionCreators as ActionCreatorsTransplanted, IDashRegistrationForTransplantedList, IDashRegistrationsForTransplantedResponse, IDataForTransplantedResponse, IMarkTransplantedRequest, IRecipientForTransplantedList } from './actions-transplanted';
import { ActionCreators as ActionCreatorsStatus, IChangeStatusRequest, IChangeStatusResponse, IBulkChangeStatusResponse, IBulkChangeStatusResult, BulkChangeStatusOutcome } from './actions-status';
import { IMicrositeRecipientLinkedEntityList } from '@nkr/models/microsites/microsite-recipient-linked-entity';

export interface ICoach {
    id: number;
    contactId?: number;
    name: string;
    firstName: string;
    lastName: string;
    email: string;
    micrositeCurrentCaseLoad: number;
    micrositeMaxCaseLoad: number;
}

export const ActionTypes = {}

export interface IMicrositeDashRegistration {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    age: number
}

export interface IMicrositeResponse {
    data: {
        success: boolean,
        message: string,
        results: IMicrositeRecipient
    }
}

export interface IMicrositeListResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            list: IMicrositeRecipientForList[],
            count: number
        }
    }
}

export interface IMicrositeCountResponse {
    data: {
        success: boolean,
        message: string,
        results: IMicrositeCounts
    }
}

export interface IMicrositeLookupDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            statusList: IListItem[],
            genderList: IListItem[],
            stateList: IListItem[],
            donorOriginList: IListItem[],
            emailTypeList: IListItem[],
            languageList: IListItem[],
            micrositeTypeList: IListItem[],
            dashRegistrationList: IMicrositeDashRegistration[],
            coordinatorList: IContact[],
            coachList: IContact[],
            centerList: ICenterBase[],
            aboTypeList: IListItem[],
            eventTypeList: IListItem[],
            messageStatusList: IListItem[],
            coachStatusList: IListItem[],
            armedServiceList: IListItem[],
            commStatusList: IListItem[],
            employmentStatusList: IListItem[]
        }
    }
}

export interface IMicrositeEmailTypeListResponse {
    data: {
        success: boolean,
        message: string,
        results: IListItem[]
    }
}

export interface IMicrositeLinkedEntities {
    data: {
        success: boolean,
        results: IMicrositeRecipientLinkedEntityList[]
    }
}

export interface IMicrositeShortCodeResponse {
    data: {
        success: boolean,
        message: string,
        results: string
    }
}

export interface ICreateCardBatchResponse {
    data: {
        success: boolean,
        results: {
            id: number,
            filename: string
        }
    }
}

export interface IExistingRegistrationsResponse {
    data: {
        success: boolean,
        message: string,
        results: IExistingRegistration[]
    }
}

export interface IRemoteDonorRegistrationResponse {
    data: {
        success: boolean,
        message: string,
        results: IRemoteDonorRegistration
    }
}

export interface IMicrositeRecipientSurveyRequest {
    micrositeRecipientId: number,
    isOnDialysis: boolean | null,
    dialysisType: number | null,
    dialysisStartDate: string | null,
    egfr: number | null,
    communityOrgReligious: boolean,
    communityOrgYmca: boolean,
    communityOrgPta: boolean,
    communityOrgOther: boolean,
    communityOrgOtherDetails: string,
    socialFacebook: boolean,
    socialInstagram: boolean,
    socialTikTok: boolean,
    socialLinkedIn: boolean,
    socialNone: boolean,
    socialOther: boolean,
    socialOtherDetails: string,
    commPhoneCall: boolean,
    commText: boolean,
    commEmail: boolean,
    commNoPreference: boolean,
    employmentStatus: number | null,
    isMilitaryVeteran: boolean | null,
    branchOfService: number | null,
    preferredContactTime: number | null
}

export interface IMicrositeRecipientSurveyResponse {
    data: {
        success: boolean,
        results: {
            survey: IMicrositeRecipientSurveyRequest | null,
            employmentStatusList: IListItem[]
        }
    }
}

export interface ISaveMicrositeRecipientSurveyResponse {
    data: {
        success: boolean,
        results: boolean
    }
}

export const ActionCreatorsMain = {
    getMicrositeList: (coachContactId: number, centerId: number, status: number, type: number, startDate: string, endDate: string, search: string, campaign: string, listType: MicrositeListType, micrositeId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IMicrositeListResponse> => {
        let options = {
            url: `${__API__}/microsite/list?coachContactId=${coachContactId}&centerId=${centerId}&listType=${listType}&status=${status}&type=${type}&startDate=${startDate}&endDate=${endDate}&search=${search}&campaign=${campaign}&micrositeId=${micrositeId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getPedsMicrositeList: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IMicrositeListResponse> => {
        let options = {
            url: `${__API__}/microsite/pediatric-list?centerId=${centerId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getMicrositeLinkedEntities: (micrositeId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IMicrositeLinkedEntities> => {
        let options = {
            url: `${__API__}/microsite/${micrositeId}/linked-entities`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getMicrositeCounts: (centerId: number, liverOnly: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IMicrositeCountResponse> => {
        let options = {
            url: `${__API__}/microsite/counts?centerId=${centerId}&liverOnly=${liverOnly}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getMicrosites: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IMicrositeListResponse> => {
        let options = {
            url: `${__API__}/microsite?centerId=${centerId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
            // return await Promise.resolve(response);
        } catch (error) {
            throw error;
        }
    },
    getCoachSettings: () => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let url = `${__API__}/admin/microsites/report/coach`;

        let options = {
            url: url
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getMicrosite: (id: number, forCoach: boolean, confirm?: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IMicrositeResponse> => {
        let options = {
            url: `${__API__}/microsite/${id}?forCoach=${forCoach}&confirm=${confirm == undefined ? false : confirm}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    getLookupData: (centerId: number, micrositeRecipientId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IMicrositeLookupDataResponse> => {
        let options = {
            url: `${__API__}/microsite/lookup-data?centerId=${centerId}&micrositeRecipientId=${micrositeRecipientId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getShortCode: (type: ShortCodeType) => async (dispatch: Dispatch<IApplicationState>): Promise<IMicrositeShortCodeResponse> => {
        let options = {
            url: `${__API__}/microsite/short-code/${type}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    getRecipientSurvey: (micrositeRecipientId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IMicrositeRecipientSurveyResponse> => {
        let options = {
            url: `${__API__}/microsite/${micrositeRecipientId}/survey`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    saveRecipientSurvey: (request: IMicrositeRecipientSurveyRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<ISaveMicrositeRecipientSurveyResponse> => {
        let options = {
            url: `${__API__}/microsite/${request.micrositeRecipientId}/survey`,
            data: request
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },

    saveMicrosite: (request: IMicrositeRecipientRequest) => async (dispatch: Dispatch<IApplicationState>): Promise<IMicrositeResponse> => {
        let options = {
            url: `${__API__}/microsite`,
            data: request
        };

        if (request.id == 0) {
            try {
                return await dispatch(AuthActionCreators.apiPost(options));
            } catch (error) {
                throw error;
            }
        } else {
            try {
                return await dispatch(AuthActionCreators.apiPut(options));
            } catch (error_1) {
                throw error_1;
            }
        }
    },
    approve: (id: number, editKey: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPut = {
            url: `${__API__}/microsite/${id}/${editKey}/approve`
        };

        try {
            return await dispatch(AuthActionCreators.apiPut(options));
        } catch (error) {
            throw error;
        }
    },
    decline: (id: number, editKey: string, isFixable: boolean, reason: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPut = {
            url: `${__API__}/microsite/${id}/${editKey}/decline`,
            data: {
                isFixable,
                reason
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPut(options));
        } catch (error) {
            throw error;
        }
    },

    reactivate: (id: number, editKey: string, statusId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPut = {
            url: `${__API__}/microsite/${id}/${editKey}/reactivate/${statusId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiPut(options));
        } catch (error) {
            throw error;
        }
    },
    deny: (id: number, editKey: string, reason: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPut = {
            url: `${__API__}/microsite/${id}/${editKey}/deny`,
            data: {
                reason
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPut(options));
        } catch (error) {
            throw error;
        }
    },
    saveProfile: (id: number, patientStoryPending: string, patientWhyPending: string, images: { displayOrder: number, caption: string }[], initials: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/microsite/profile`,
            data: {
                id,
                patientStoryPending,
                patientWhyPending,
                images,
                initials
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    updateCoachSettings: (coaches: ICoach[]) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/admin/microsites/coach/update`,
            data: coaches
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    sendReminderEmail: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IGet = {
            url: `${__API__}/microsite/${id}/email/9`,
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    bulkSendEmail: (list: { id: number, emailType: number }[]) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/microsite/bulk-send-email`,
            data: list
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    resendApprovalEmail: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IGet = {
            url: `${__API__}/microsite/${id}/email/10`,
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    downloadCardBatchFile: (id: number) => (dispatch: Dispatch<IApplicationState>) => {
        let options: IGet = {
            url: __API__ + '/microsite/card-batch/' + id,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },
    createCardBatchFile: () => async (dispatch: Dispatch<IApplicationState>): Promise<ICreateCardBatchResponse> => {
        let options: IPost = {
            url: `${__API__}/microsite/card-batch/create`,
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    updateMicrosite: (data: IMicrositeRecipient) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let { id, editKey, email, secondaryEmail, phonePrimary, phoneSecondary, mostRecentCoachContactDateTime } = data;

        let options: IPost = {
            url: `${__API__}/microsite`,
            data: {
                id,
                editKey,
                email,
                secondaryEmail,
                phonePrimary,
                phoneSecondary,
                mostRecentCoachContactDateTime
            }
        };

        try {
            return await dispatch(AuthActionCreators.apiPut(options));
        } catch (error) {
            throw error;
        }
    },
    sendEmail: (id: number, emailType: MicrositeEmailType) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IGet = {
            url: `${__API__}/microsite/${id}/email/${emailType}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    sendText: (id: number, emailType: MicrositeEmailType) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IGet = {
            url: `${__API__}/microsite/${id}/text/${emailType}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },


    getMicrositeEmailTypes: () => async (dispatch: Dispatch<IApplicationState>): Promise<IMicrositeEmailTypeListResponse> => {
        let options = {
            url: `${__API__}/microsite/email-types`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    checkForExistingRegistrations: (email: string, firstName: string, lastName: string, birthDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IExistingRegistrationsResponse> => {
        let options: IPost = {
            url: `${__API__}/microsite/existing-registrations`,
            data: {
                email,
                firstName,
                lastName,
                birthDate
            }
        };

        try {
            const response = await dispatch(AuthActionCreators.apiPost(options));
            return response;
        } catch (error) {
            throw error;
        }
    },

    registrationsForRemotePatients: (donationType: number, centerId: number, firstName: string, lastName: string, lastInitial: string, statusType: number[],
        micrositeRecipientId: number, onlyComplete: boolean, limitStart: number, limitEnd: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IRemoteDonorRegistrationResponse> => {
            let options: IPost = {
                url: `${__API__}/microsite/registrations-remote-patients`,
                data: {
                    donationType,
                    centerId,
                    firstName,
                    lastName,
                    lastInitial,
                    statusType,
                    micrositeRecipientId,
                    onlyComplete,
                    limitStart,
                    limitEnd
                }
            };

            try {
                const response = await dispatch(AuthActionCreators.apiPost(options));
                return response;
            } catch (error) {
                throw error;
            }
        },

    updateAssignedCoach: (micrositeId: number, coachContactId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/microsite/${micrositeId}/update-assigned-coach?coachContactId=${coachContactId}`
        };

        try {
            const response = await dispatch(AuthActionCreators.apiPost(options));
            return response;
        } catch (error) {
            throw error;
        }
    },

    convertDonor: (data: IMicrositeConvertDonationType) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorConversionPostResponse> => {
        let url = `${__API__}/microsite/${data.centerId}/donation-type-convert`;
        let options = {
            url,
            data
        }
        return await dispatch(AuthActionCreators.apiPost(options));
    },
}

export const ActionCreators = {
    ...ActionCreatorsMain,
    ...ActionCreatorsCampaign,
    ...ActionCreatorsCoach,
    ...ActionCreatorsTransplanted,
    ...ActionCreatorsStatus
};

export {
    IMicrositeCampaignListResponse, IMicrositeCampaignResponse, IMicrositeCampaignValidatedMailingListResponse, IMicrositeCampaignLookupDataResponse,
    ICoachLogEntryResponse, ICommunicationResponse, IChangeCoachStatusRequest,
    IDashRegistrationForTransplantedList, IDashRegistrationsForTransplantedResponse, IDataForTransplantedResponse, IMarkTransplantedRequest, IRecipientForTransplantedList,
    IChangeStatusRequest, IChangeStatusResponse, IBulkChangeStatusResponse, IBulkChangeStatusResult, BulkChangeStatusOutcome
}

export interface IMicrositeState { }

let initialState: IMicrositeState = {};

const createReducer = (initialState: IMicrositeState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {};

export const Reducer = createReducer(initialState, handlers);
